import { createApp } from 'vue'
import router from '@/router/index'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css';
import "@/static/css/bootstrap.min.css";
import "@/static/css/nivo-slider.css";
import "@/static/css/core.css";
import "@/static/css/shortcodes.css";
import "@/static/css/style.css";
import "@/static/css/responsive.css";
import "@/static/css/custom.css";
import "@/static/css/style-customizer.css";
// import "@/static/js/modernizr-2.8.3.min.js";
// import "@static/js/jquery-3.1.1.min.js";
// import "@/static/js/bootstrap.min.js";
// import "@/static/js/jquery.nivo.slider.js";
// import "@/static/js/ajax-mail.js";
// import "@/static/js/plugins.js";
// import "@/static/js/main.js";
import App from './App.vue'
const app = createApp(App)
app.use(ElementPlus),
app.use(router)
app.mount('#app')
app.config.globalProperties.globalData={
    num:'sssss'
}
